export default "__VITE_ASSET__lu44qnZH__"